import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Camera, Heart } from "lucide-react";
import { useFlow } from "@/flowStore";

function CloudPill({ text, fontSize, rotate = 0, px = 18, py = 6, marginLeft = 0, marginTop = 0 }) {
  return (
    <span
      className="cloud-pill"
      style={{
        fontSize,
        transform: `rotate(${rotate}deg)`,
        padding: `${py}px ${px}px`,
        marginLeft,
        marginTop,
      }}
    >
      {text}
    </span>
  );
}

export default function Welcome() {
  const navigate = useNavigate();
  const { reset } = useFlow();

  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <div className="screen" data-testid="welcome-screen">
      <div className="gradient-bg" />

      <button
        className="admin-lock"
        data-testid="admin-link"
        onClick={() => navigate("/admin")}
        aria-label="Espace équipe"
      >
        <Lock size={14} color="rgba(255,255,255,0.75)" />
      </button>

      <div className="screen-scroll">
        <div className="welcome-content fade-up">
          <div className="title-cluster">
            <CloudPill text="Le défi" fontSize={48} rotate={-3} marginLeft={8} px={20} py={2} />
            <CloudPill text="du Stamm" fontSize={56} rotate={1} marginTop={-8} marginLeft={30} px={22} py={2} />
            <CloudPill text="Une photo," fontSize={32} rotate={3} marginTop={2} marginLeft={60} py={4} />
            <CloudPill text="un verre !" fontSize={32} rotate={-2} marginTop={0} marginLeft={130} py={4} />
          </div>

          <p className="body-text">
            Prends-toi en photo autour du stammtisch, partage-là avec nous et tente de remporter un
            coffret d&apos;été des vins de Cave de La Côte.
          </p>

          <button
            className="cta-wrap"
            data-testid="start-challenge-button"
            onClick={() => navigate("/capture")}
          >
            <div className="cta">
              <Camera size={28} color="#E97160" />
              <span className="cta-text">je participe</span>
            </div>
          </button>

          <div className="welcome-bottom">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
              <div className="heart-circle">
                <Heart size={26} color="#E97160" fill="#E97160" />
              </div>
              <span className="heart-caption">
                fait avec amour
                <br />
                par Cave de La Côte
              </span>
            </div>
            <p className="legal">
              En participant, tu acceptes que ta photo et ton e-mail soient utilisés pour le concours
              Cave de La Côte.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
